
import React from "react";
import { Offcanvas, OffcanvasProps } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";

export type DefaultOffCanvasProps = {
} & OffcanvasProps & React.HTMLAttributes<HTMLDivElement>;

const DefaultOffCanvas = (props: DefaultOffCanvasProps) => {
    const { className } = props;

    return (
        <Offcanvas
            zIndex={30002}
            {...props}
            className={cx({
                [className || ""]: className,
                [styles.off_canvas]: true
            })}
        >
            {props.children}
        </Offcanvas>
    );
}
export default DefaultOffCanvas;
